export default {
	common: {
		search_for: 'Suche: {query}',
		online: 'Online',
		offline: 'Offline',
		view_details: 'Details anzeigen',
		clear: 'Zurücksetzen',
	},
	sidebar: {
		header_me: 'Willkommen, {firstname}!',
		header_admin: 'Administration',
		tools: {
			_: 'Tools',
			decommission: 'Dekommissionieren',
			site_search: 'UniFi Site Suche',
			prepare_site: 'UniFi Site Vorbereiten',
		},
	},
	tabs: {
		admin_settings: {
			network_lists: 'Netzwerklisten',
		},
	},
	pages: {
		home: {
			welcome_text: 'Hallo Welt',
		},
		admin: {
			settings: {
				network_lists: {
					vlan: {
						title: 'VLAN Listen',
						columns: {
							vlan_id: 'VLAN ID (1-4093)',
							name: 'Name des VLANs',
							subnet: 'Subnetz des VLANs in CIDR Notation',
							router_ip: 'IP Adresse des Routers',
							dhcp_start: 'Erste IP Adresse des DHCP Pools',
							dhcp_end: 'Letzte IP Adresse des DHCP Pools',
						},
					},
					fixed_ip: {
						title: 'Feste IP Lease Listen',
						columns: {
							mac: 'MAC Adresse des Hosts',
							hostname: 'Hostname des Hosts',
							ip: 'IP Adresse des Hosts',
							vlan_id: 'VLAN ID, in welchem die statische Lease angelegt werden soll',
						},
					},
					columns: {
						name: 'Datei',
						size: 'Größe',
						last_modified: 'Zuletzt geändert',
					},
					default: 'Standard',
					set_default: 'Als Standard festlegen',
					empty: 'Noch keine Listen hochgeladen',
					delete_confirm: {
						title: 'Liste löschen?',
						body: 'Möchtest du "{name}" wirklich löschen? Dies kann nicht rückgängig gemacht werden.',
					},
					upload: {
						title: '{list} hochladen',
						submit: 'Hochladen',
						no_file: 'Bitte wähle eine CSV-Datei zum Hochladen aus.',
						failed: 'Die Datei konnte nicht hochgeladen werden.',
						hint_vlan: 'Erwartet wird eine kommagetrennte CSV mit folgenden Spalten:',
						hint_fixed_ip: 'Erwartet wird eine semikolongetrennte CSV mit folgenden Spalten:',
					},
					toasts: {
						load_failed: {
							title: 'Laden fehlgeschlagen',
							body: 'Die Netzwerklisten konnten nicht geladen werden',
						},
						uploaded: {
							title: 'Liste hochgeladen',
							body: '"{name}" wurde erfolgreich hochgeladen',
						},
						delete_failed: {
							title: 'Löschen fehlgeschlagen',
							body: 'Die Liste konnte nicht gelöscht werden',
						},
						default_failed: {
							title: 'Standard nicht gesetzt',
							body: 'Die Standardliste konnte nicht aktualisiert werden',
						},
					},
				},
			},
		},
		tools: {
			decommission: {
				title: 'Dekommissionieren',
				status: {
					unknown: 'Unbekannter Status',
					waiting: 'Warte auf Ausführung ...',
					searching: 'Suche nach Gerät "{device_code}" ...',
					running: 'In Arbeit ...',
					success: 'Abgeschlossen',
					failed: 'Fehlgeschlagen: {error}',
					failed_step: 'Fehlgeschlagen während {step}: {error}',
					waiting_on_step: 'Warte auf {step}',
				},
				exceptions: {
					unknown: 'Unbekannter Fehler',
					no_device_data: 'Keine Gerätedaten',
					not_found: 'Nicht gefunden',
					device_not_supported: 'Unbekannter Gerätetyp',
					invalid_device_code: 'Ungültiges Label "{device_code}"',
					uncallable_step: 'Zwischenschritt "{step_name}" existiert nicht',
					default_vlan_list_not_set:
						'Es ist keine Standard-VLAN-Liste festgelegt. Bitte lege in den Netzwerklisten-Einstellungen eine fest, bevor Switche dekommissioniert werden.',
					default_site_not_found: 'Die UISP-Site "Default" existiert nicht',
					tcm_not_es8: 'Das TCM-Gerät "{code}" ist kein EdgeSwitch 8',
				},
				toasts: {
					request_running: {
						title: 'Request in Warteschlange',
						body: 'Der Request für Gerätecode "{device_code}" befindet sich bereits in der Warteschlange',
					},
					requeue_request: {
						title: 'Request bereits durchgeführt',
						body: 'Der Request für Gerätecode "{device_code}" wurde bereits durchgeführt. Scanne das Gerät nochmal, um einen weiteren Request zu starten.',
					},
					failed_to_queue: {
						title: 'Request fehlgeschlagen',
						body: 'Der Request für Gerätecode "{device_code}" konnte nicht erstellt werden: {error}',
					},
				},
				steps: {
					unknown: 'Unbekannter Schritt',
					waitForDeviceOnline: 'Warte auf Gerät',
					enableMaintenance: 'Maintenance aktivieren',
					moveToDefaultSite: 'Auf Default Site verschieben',
					setDeviceName: 'Gerätenamen setzen',
					updateVlanList: 'VLANs aktualisieren',
					configurePorts: 'Ports konfigurieren',
					waitForProvisioning: 'Warte auf Provisionierung',
					startDeviceLocate: 'Device Locate aktivieren',
				},
			},
			site_search: {
				title: 'UniFi Site Suche',
				search_label: 'Suche...',
				search_placeholder: 'Gerätename oder MAC-Adresse ...',
				search_failed: 'Die Suche ist fehlgeschlagen',
				no_results: 'Keine Ergebnisse für "{query}"',
				status: {
					ambiguous: 'Mehrere Geräte gefunden',
					ready: 'Bereit zum Verschieben',
					moving: 'Verschiebe ...',
					moved: 'Verschoben',
				},
				multiple_results: 'Mehrere passende Geräte gefunden:',
			},
			prepare_site: {
				title: 'UniFi Site Vorbereiten',
				select_site: 'UniFi Site auswählen',
				select_placeholder: 'Auswählen ...',
				loading_sites: 'Lade Sites ...',
				loading_summary: 'Lade Site Details ...',
				stats: {
					online_for: 'Site online seit',
					offline: 'Offline',
					online_devices: 'Geräte online',
					active_clients: 'Aktive Clients',
					access_points: 'APs (Online/Gesamt)',
					switches: 'Switches (Online/Gesamt)',
					routers: 'Router (Online/Gesamt)',
					networks: 'Netzwerke (Aktiviert/Gesamt)',
					wireless_networks: 'WiFi SSIDs (Aktiviert/Gesamt)',
				},
				options: {
					title: 'Site Optionen',
					import_vlans: 'VLANs importieren',
					import_vlans_only: 'VLANs ohne Subnetze importieren',
					overwrite_existing_vlans: 'Bestehende VLANs überschreiben',
					vlan_list: 'VLAN-Liste',
					import_fixed_ips: 'Feste IPs aus CSV importieren',
					fixed_ip_list: 'Feste-IP-Liste',
					purge_networks: 'Alle bestehenden VLANs löschen',
					purge_wireless_networks: 'Alle bestehenden WiFi SSIDs löschen',
					purge_fixed_ips: 'Alle bestehenden festen IPs löschen',
					reset_access_point_configurations: 'AP-Konfigurationen zurücksetzen',
					enable_wan_dhcp: 'DHCP auf WAN für bestehende Router aktivieren',
				},
				prepare: 'Site vorbereiten',
				back: 'Zurück',
				eligibility: {
					blocked_reason:
						'Die Site "{site}" ist bereits längere Zeit online und wirkt wie eine aktive Site, daher kann sie nicht vorbereitet werden. Die Vorbereitung ist destruktiv und nur bei frisch eingerichteten oder offline Sites möglich.',
				},
				progress_title: 'Vorbereitung der Site "{site}"',
				history: {
					title: 'Site-Vorbereitungsverlauf',
					back: 'Zurück zum Tool',
					running: 'In Arbeit ...',
					steps: 'Schritte',
					columns: {
						id: 'ID',
						site_description: 'Site',
						site_name: 'Interner Site-Name',
						created_at: 'Gestartet am',
						completed_at: 'Abgeschlossen am',
						error: 'Status',
					},
				},
				confirm: {
					title: 'Site vorbereiten?',
					body: 'Soll die Site "{site}" wirklich vorbereitet werden? Die Site wird mit den gewählten Optionen neu konfiguriert.',
				},
				status: {
					waiting: 'Warte auf Ausführung ...',
					success: 'Site-Vorbereitung abgeschlossen',
					failed: 'Site-Vorbereitung fehlgeschlagen: {error}',
				},
				errors: {
					unknown: 'Unbekannter Fehler',
				},
				toasts: {
					load_failed: {
						title: 'Laden fehlgeschlagen',
						body: 'Die UniFi Site-Daten konnten nicht geladen werden',
					},
					failed_to_queue: {
						title: 'Request fehlgeschlagen',
						body: 'Die Vorbereitung der Site "{site}" konnte nicht gestartet werden',
					},
					completed: {
						title: 'Site vorbereitet',
						body: 'Die Site "{site}" wurde erfolgreich vorbereitet',
					},
					failed: {
						title: 'Site-Vorbereitung fehlgeschlagen',
						body: 'Die Vorbereitung der Site "{site}" ist fehlgeschlagen',
					},
				},
			},
		},
	},
	exceptions: {
		no_device_data: 'Keine Gerätedaten gefunden',
	},
	modules: {
		etherforce: {
			network_devices: {
				exceptions: {
					device_not_found: 'Kein Gerät für "{identifier}" gefunden',
					device_unreachable: 'Gerät {device_name} ist nicht erreichbar',
					invalid_device_code: 'Ungültiger Gerätecode "{device_code}"',
					no_controller_service:
						'Gerätetyp für "{identifier}" ist bekannt, ist jedoch keiner NetworkController-Klasse zugewiesen',
					unknown_device_type: 'Gerätetyp für "{identifier}" ist nicht bekannt',
				},
			},
		},
	},
};
